import React, { useMemo } from 'react';
import { Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import AppLoading from '@Common/appAsyncLoading';

import enhanceRouter from '@App/hoc/enhanceRouter';

const asyncComponent = Component => {
  return Loadable({
    loader: Component,
    loading: AppLoading,
    delay: 200,
    timeout: 10000
  });
};

const lazyRouteName = ({ component: Component, ...rest }) => {
  const EnhancedComponent = useMemo(
    () => enhanceRouter({ ...rest })(asyncComponent(Component)),
    [rest.path, rest.name]
  );
  return <Route {...rest} component={EnhancedComponent} />
};

lazyRouteName.defaultProps = {
  name: '',
  nameDrawer: '',
  propsRoot: {}
};

export default lazyRouteName;